import { useEffect, useRef, useState } from "react";
import styles from "../Functions.module.css";
import CheckboxTree from "react-checkbox-tree";
import {ReactComponent as Checked} from "../../../Icons/Checked_Checkbox.svg";
import {ReactComponent as Unchecked} from "../../../Icons/uncheckedCheckbox.svg"
import {ReactComponent as DownArrow} from "../../../Icons/ArrowDown.svg";
import {ReactComponent as RightArrow} from "../../../Icons/ArrowRight.svg";

const InputParameters = ({
  isMF,
  DO,
  inputDataObjects,
  setInputDataObjects,
  prevValue,
  isDataLoaded,
  setIsDataLoaded
}) => {
  const [checked, setChecked] = useState([]);

  const nodes = useRef(DO);
  const [expanded, setExpanded] = useState([nodes.current[0]?.value]);
  const checkedData = useRef([])

  useEffect(() => {
    let temp = []
    inputDataObjects?.map((data) => {
      temp.push(data.SystemDefinedName)
    })
    setChecked(temp)
  }, [])

  useEffect(() => {
    if(isDataLoaded){
      nodes.current = DO
      setExpanded([nodes.current[0]?.value])
      let temp = []
      inputDataObjects?.map((data) => {
        temp.push(data.SystemDefinedName)
      })
      setChecked(temp)
      setIsDataLoaded(false)
      window.loading(false)
    }
  }, [DO])

  useEffect(() => {
    if(isMF){
      let temp = []
    inputDataObjects?.map((data) => {
      temp.push(data.SystemDefinedName)
    })
    setChecked(temp)
    }
  }, [isMF, inputDataObjects])
  
  const newInputObj = (obj) => {
    obj.map((item) => {
      if(checked.includes(item?.value)){
        let obj = {
          SystemDefinedName : item?.value,
          VariableName: item?.VarName
        }
        checkedData.current.push(obj)
      }
      if(item.children && item?.children?.length > 0){
        newInputObj(item.children)
      }
    })
  }

  useEffect(() => {
    checkedData.current = []
    newInputObj(DO)
    console.log(checkedData.current)
    setInputDataObjects(checkedData.current);
  }, [checked]);

  return (
    <>
      <div className={styles.inputBody}>
        <CheckboxTree
          nodes={nodes?.current}
          checked={checked}
          expanded={expanded}
          iconsClass="fa5"
          icons={{
            check: <Checked />,
            uncheck: <Unchecked />,
            halfCheck: <Checked />,
            expandClose: <RightArrow />,
            expandOpen: <DownArrow />,
            expandAll: <span className="rct-icon rct-icon-expand-all" />,
            collapseAll: <span className="rct-icon rct-icon-collapse-all" />,
            parentClose: <span className="rct-icon rct-icon-parent-close" />,
            parentOpen: <span className="rct-icon rct-icon-parent-open" />,
            leaf: <span className="rct-icon rct-icon-leaf" />,
          }}
          onCheck={(checkedData) => {
            setChecked(checkedData);
          }}
          onExpand={(expandedData) => {
            setExpanded(expandedData);
          }}
          disabled={isMF || prevValue[0]?.status === "0"}
        />
      </div>
    </>
  );
};

export default InputParameters;
